mutation DeleteChatBan($id: ID!) {
  deleteChatBan(id: $id) {
    id
  }
}
